import React from "react";
import { connect } from "react-redux";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { Button } from "react-bootstrap";
import { grtAllCompanylistbyVendorId } from "../../actions/MasterTemplateActions";
var CryptoJS = require("crypto-js");

class Changecompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      contactownerdata: [],
      ownerId: "",
      companyname: "",
    };
  }
  componentDidMount() {
    this.props.grtAllCompanylistbyVendorId().then((res) => {
      this.setState({ contactownerdata: res.data, showLoader: false });
    });
  }
  getownerIdBycompanyDropdown = (e) => {
    // localStorage.setItem("ownerId", e.target.value);
    let selectedCompanyname = this.state.contactownerdata.find(
      (element) => element._id == String(e.target.value)
    );
    this.setState({
      ownerId: e.target.value,
      companyname: selectedCompanyname,
    });
    // console.log("element282", selectedCompanyname);
    // localStorage.setItem(
    //   "companyName",
    //   selectedCompanyname.companyInformation.name
    // );
    // this.props.history.push("/UserProfile");
  };

  SelectAndClose = () => {
    this.props.chooseComapnyCallback(
      this.state.ownerId,
      this.state.companyname
    );
  };

  render() {
    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <label>Select Studio</label>
          <div>
            <FormControl sx={{ m: 0, width: 300 }} size="large">
              <InputLabel id="demo-select-large">Studio</InputLabel>
              <Select
                labelId="company"
                id="company"
                label="Page"
                onChange={this.getownerIdBycompanyDropdown}
              >
                {this.state.contactownerdata &&
                  this.state.contactownerdata.map((item) => {
                    return (
                      <MenuItem value={item._id}>
                        {item.companyInformation.name}
                      </MenuItem>
                    );
                  })}
              </Select>
              {this.state.selectError ? (
                <p style={{ color: "red" }}> Please select any studio</p>
              ) : (
                ""
              )}
            </FormControl>
          </div>
          <div style={{ marginTop: "10px" }}>
            <Button
              onClick={() => {
                this.SelectAndClose();
              }}
              className="btn btn-primary btn-blue btn-head w-140"
            >
              Continue
            </Button>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {};
};
export default connect(
  mapStateToProps,
  { grtAllCompanylistbyVendorId }
)(Changecompany);
